import { render, staticRenderFns } from "./ConfirmationStep.vue?vue&type=template&id=fda41036&scoped=true"
import script from "./ConfirmationStep.vue?vue&type=script&lang=js"
export * from "./ConfirmationStep.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationStep.vue?vue&type=style&index=0&id=fda41036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda41036",
  null
  
)

export default component.exports